import React from 'react';
import Navigation from '../components/Navigation';

const FAQ = () => {
    const faqs = [
        {
            question: "How can I update my guests’ details? (E.g. dietary restrictions, name, address)",
            answer: "Your guest can access their invitation again and update their details! The email address cannot be updated because it has to be unique for us to keep track of them!"
        },
        {
            question: "I see “Table 1”, “Table 2”, etc. Does this reflect my table number for the luncheon?",
            answer: "Nope! This is just to keep track of the number of tables you are in charge of filling for the event."
        },
        {
            question: "I moved someone to another table but it didn’t save! Why?",
            answer: "You have to click “Save Changes” in order to save your table placement."
        },
        {
            question: "Why am I (a table captain) already a guest at my table?",
            answer: "We automagically added you so you didn’t have to think about it! You can always remove yourself if you won’t be sitting at your table."
        },
        {
            question: "What if my guest accidentally declined but now they want to come?",
            answer: "You can invite them again! Just go through the invite guest flow. If they try to access their original invitation again, it won’t work."
        },
        {
            question: "Why can’t I send more than 10 invites?",
            answer: "Your table seats 10 people. Once you send 10 invitations, you will have the option to apply for a second table."
        },
        {
            question: "How can I get a second table?",
            answer: "Once you invite at least 10 guests, you have the option to apply for a second table. Your additional table(s) request will need to be approved by the Raising Girls Luncheon Team.",
            visual: (
                <div style={{
                    marginTop: '1.5rem',
                    background: 'linear-gradient(135deg, rgba(80, 20, 20, 0.8), rgba(40, 10, 10, 0.9))',
                    border: '1px solid rgba(241, 89, 42, 0.3)',
                    borderRadius: '0.75rem',
                    padding: '1.5rem',
                    textAlign: 'center',
                    maxWidth: '400px'
                }}>
                    <p style={{ color: '#e4e4e7', marginBottom: '1rem', fontSize: '0.95rem' }}>
                        You have filled your current tables.<br />Need more space?
                    </p>
                    <button style={{
                        background: 'transparent',
                        border: '1px solid rgba(255, 255, 255, 0.3)',
                        color: 'white',
                        padding: '0.5rem 1rem',
                        borderRadius: '0.5rem',
                        cursor: 'default', // Non-interactive example
                        fontSize: '0.9rem',
                        fontWeight: '500'
                    }}>
                        Request Additional Table
                    </button>
                    <p style={{ fontSize: '0.8rem', color: '#a1a1aa', marginTop: '0.5rem', fontStyle: 'italic' }}>
                        (Example of what you'll see)
                    </p>
                </div>
            )
        },
        {
            question: "What if I try to invite someone but they are getting this error “Invalid invite code. Please check your code and try again.”",
            answer: "This means your guest declined an invite, someone else invited your guest to sit at their table, and the guest tried their old invited code."
        }
    ];

    return (
        <div className="faq-container" style={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            color: 'var(--text-color)'
        }}>
            <Navigation />
            <div className="faq-content" style={{
                flex: 1,
                padding: '2rem',
                maxWidth: '800px',
                margin: '0 auto',
                width: '100%'
            }}>
                <h1 style={{
                    fontSize: '3rem',
                    fontWeight: '700',
                    marginBottom: '2rem',
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--accent-color) 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    textAlign: 'center'
                }}>
                    Frequently Asked Questions
                </h1>

                <div className="faq-list" style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                    {faqs.map((faq, index) => (
                        <div key={index} className="faq-item" style={{
                            background: 'rgba(255, 255, 255, 0.03)',
                            padding: '2rem',
                            borderRadius: '1rem',
                            border: '1px solid rgba(255, 255, 255, 0.05)',
                            backdropFilter: 'blur(10px)'
                        }}>
                            <h3 style={{
                                fontSize: '1.25rem',
                                fontWeight: '600',
                                marginBottom: '1rem',
                                color: '#f3f4f6'
                            }}>
                                {faq.question}
                            </h3>
                            <p style={{
                                fontSize: '1rem',
                                lineHeight: '1.6',
                                color: '#d1d5db'
                            }}>
                                {faq.answer}
                            </p>
                            {/* Render visual if present */}
                            {faq.visual}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FAQ;
